import { render, staticRenderFns } from "./QExpand.vue?vue&type=template&id=472d84c6&"
import script from "./QExpand.vue?vue&type=script&lang=js&"
export * from "./QExpand.vue?vue&type=script&lang=js&"
import style0 from "./QExpand.vue?vue&type=style&index=0&id=472d84c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports